import type { ReactNode } from 'react';
import React, { useContext } from 'react';

export interface ThreadContextValues {
  threadId: string;
  pageId: string;
  slug: string;
  // isEditing?: boolean; // It has a separate context because the value can change with the authentication status. All values here should be constant.
  isAnswering?: boolean;
}

const threadContext = React.createContext<ThreadContextValues>({} as ThreadContextValues);

export const ThreadContextProvider = ({
  initialValues,
  children,
}: {
  initialValues: ThreadContextValues;
  children: ReactNode;
}) => {
  return <threadContext.Provider value={initialValues}>{children}</threadContext.Provider>;
};

export const useThreadContext = () => {
  const context = useContext(threadContext);
  if (context === undefined)
    throw new Error('useThreadContext must be used within a ThreadContextProvider');

  return context;
};
